export default "__VITE_ASSET__e0b5494d__"